import * as React from "react";
import { ProfileMenu } from "./UserMenu";
import { GenericCreate } from "./GenericCreate";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Terminal } from "react-feather";
import { AdminPanelSession } from "./AdminPanelSession";
import { OrgInactiveAlert } from "./OrgInactiveAlert";
import { CircularThemeSwitch } from "../../CircularThemeSwitch/CircularThemeSwitch";
import { DisallowedEmail } from "./DisallowedEmail";
import { TimezoneDisplay } from "./TimezoneDisplay";
import { Logo } from "../sider/Logo";
import "./index.scss";
import { GlobalSearch } from "./GlobalSearch";
import { ContextWidget } from "./ContextDrawer/ContextWidget";
import { Button } from "antd";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { selectContext } from "../../../store/contextSlice";
import { selectIsAdmin } from "../../../store/userSlice";
import { applyActions } from "../../../store/applySlice";
import { NotificationBellButton } from "../../NotificationDrawer";
import { MobileMenu } from "./MobileMenu";

interface Props {
  isMenuShown?: boolean;
}

export const Header: React.FC<Props> = ({ isMenuShown = true }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const dispatch = useAppDispatch();
  const context = useAppSelector(selectContext);
  const isAdmin = useAppSelector(selectIsAdmin);
  const userType = useAppSelector((state) => state.user.type);
  const dashboard = useAppSelector((state) => state.uiData.dashboard);
  const isCreateForm = useAppSelector((state) => state.uiData.isCreateForm);

  return (
    <div className="ngheader">
      <div className="ngheader-left-controls">
        <Link
          to={
            context.org
              ? context.gvc
                ? `/console/org/${context.org}/gvc/${context.gvc}`
                : `/console/org/${context.org}`
              : pathname.includes("/home/")
              ? "/home"
              : `/`
          }
          className="ngheader-logo ngfocus"
        >
          <Logo />
        </Link>
        {isAdmin ? <AdminPanelSession /> : null}
        <ContextWidget />
        {context.org ? <OrgInactiveAlert /> : null}
        <DisallowedEmail />
      </div>
      <div className="ngheader-spacer" />
      <div className="ngheader-desktop-only">
        <GlobalSearch key={pathname} />
      </div>
      <div className="ngheader-spacer" />
      <div className="ngheader-right-controls">
        <div className="ngheader-desktop-only">
          <CircularThemeSwitch />
        </div>
        <div className="ngheader-desktop-only">
          <NotificationBellButton />
        </div>
        {!isCreateForm && userType !== "inspect" && isMenuShown && dashboard === "console" && !!context.org ? (
          <div className="ngheader-desktop-only">
            <Button
              type="text"
              onClick={() => {
                dispatch(applyActions.initialize({ itemLink: "", previousPath: pathname }));
                navigate("/console/apply");
              }}
              icon={<Terminal size={16} />}
            >
              apply
            </Button>
          </div>
        ) : null}
        {!isCreateForm && userType !== "inspect" && isMenuShown && dashboard !== "task" && !!context.org ? (
          <div className="ngheader-desktop-only">
            <GenericCreate />
          </div>
        ) : null}
        {userType !== "inspect" ? <MobileMenu /> : null}
        {userType !== "inspect" ? <ProfileMenu /> : null}
        {userType === "inspect" ? (
          <div className="text-xs">
            <TimezoneDisplay />
          </div>
        ) : null}
      </div>
    </div>
  );
};
